<template>
  <div class="my-10">
    <PopupWrapper :platform="POPUP_TYPE.WEB_MEDIA" />
    <div class="flex w-full mb-5">
      <div class="w-full grid gap-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        <router-link
          v-for="(video, index) in videos"
          :key="index"
          :to="{ name: 'mediaDetail', params: { id: video.id } }"
        >
          <MediaCard :detail="video" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import MediaCard from '@cmp/media/MediaCard.vue';
import PosterBannerSmall from '@cmp/PosterBannerSmall.vue';
import api from '@/api';
import { updateLastSeen } from '@/helpers';
import PopupWrapper from '@/components/PopupWrapper.vue';
import { POPUP_TYPE } from '@/constants';
export default {
  name: 'mediaHome',
  components: {
    MediaCard,
    PosterBannerSmall,
    PopupWrapper,
  },
  data() {
    return {
      POPUP_TYPE,
      loading: false,
      videos: [],
      publicationSmallPosters: [],
    };
  },
  methods: {
    async getPostsVideos() {
      try {
        const response = await api.get('posts/videos/', {
          params: { location: this.getLocation.id },
        });
        this.videos = response.data.results;
      } catch (e) {
        console.log(e);
      }
    },
    async getPublicationSmallPoster() {
      try {
        const response = await api.get('commercials/advertisements/', { params: { type: 212 } });
        this.publicationSmallPosters = response.data;
      } catch (e) {
        console.log(e);
      }
    },
  },
  computed: {
    getLocation() {
      return JSON.parse(localStorage.getItem('selectedLocation')) || 1;
    },
  },
  async created() {
    await this.getPostsVideos();
    await this.getPublicationSmallPoster();
    updateLastSeen('videos');
  },
};
</script>
./mediaHome.vue
